import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";
import {
  CAMPAIGN_LIST,
  CAMPAIGN_DETAILS,
  ADD_CAMPAIGN,
  UPDATE_CAMPAIGN,
  DELETE_CAMPAIGN,
  RUN_CAMPAIGN,
  BULKSUBSCRIPTIONPREVIEW,
  BULKSUBSCRIPTIONUPLOAD,
  RUNCSVCAMPAIGN,
  SMSANALYTICS,
  EMAILANALYTICS,
} from "../actions/campaign.actions.types";

const call = Effects.call;

function* getCampaignList({ payload: { data, callback } }) {
  const payload = {
    params: data,
    method: "get",
    url: "campaign/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (error) {
      callback({ success: false, data: null });
    } else {
      callback({ success: true, data: result.data });
    }
  }
}

function* campaignDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `campaign/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (error) {
      callback({ success: false, data: null });
    } else {
      callback({ success: true, data: result.data });
    }
  }
}

function* addCampaign({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "campaign",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (error) {
      callback({ success: false, data: null });
    } else {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* updateCampaign({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `campaign/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (error) {
      callback({ success: false, data: null });
    } else {
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteCampaign({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `campaign/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (error) {
      callback({ success: false, data: null });
    } else {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* runCampaign({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `campaign/sending/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (error) {
      callback({ success: false, data: null });
    } else {
      callback({ success: true, data: result.data });
    }
  }
}

function* previewBulkSubscription({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "campaign/bulk-preview-subscription",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
    formData: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}
function* uploadBulkSubscription({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "campaign/bulk-upload-subscription",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
    formData: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* runCsvCampaign({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "campaign/sending-csv-campaign",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* getSmsAnalytics({ payload: { callback } }) {
  const payload = {
    method: "get",
    url: `sms/analytics`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (error) {
      callback({ success: false, data: null });
    } else {
      callback({ success: true, data: result.data });
    }
  }
}
function* getEmailAnalytics({ payload: { callback } }) {
  const payload = {
    method: "get",
    url: `campaign/email-analytics`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (error) {
      callback({ success: false, data: null });
    } else {
      callback({ success: true, data: result.data });
    }
  }
}

function* Campaign() {
  yield all([
    takeLatest(CAMPAIGN_LIST, getCampaignList),
    takeLatest(CAMPAIGN_DETAILS, campaignDetails),
    takeLatest(ADD_CAMPAIGN, addCampaign),
    takeLatest(UPDATE_CAMPAIGN, updateCampaign),
    takeLatest(DELETE_CAMPAIGN, deleteCampaign),
    takeLatest(RUN_CAMPAIGN, runCampaign),
    takeLatest(BULKSUBSCRIPTIONPREVIEW, previewBulkSubscription),
    takeLatest(BULKSUBSCRIPTIONUPLOAD, uploadBulkSubscription),
    takeLatest(RUNCSVCAMPAIGN, runCsvCampaign),
    takeLatest(SMSANALYTICS, getSmsAnalytics),
    takeLatest(EMAILANALYTICS, getEmailAnalytics),
  ]);
}

export default Campaign;
